import { render, staticRenderFns } from "./ssoMobile.vue?vue&type=template&id=2c71d067&scoped=true&"
import script from "./ssoMobile.vue?vue&type=script&lang=js&"
export * from "./ssoMobile.vue?vue&type=script&lang=js&"
import style0 from "./ssoMobile.vue?vue&type=style&index=0&id=2c71d067&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c71d067",
  null
  
)

export default component.exports